export default __webpack_public_path__ + "static/media/timeline.d3b83859.jpg";